// React
import React from 'react';
// External
import {
    Button, Image, Row, Col, Modal
} from 'react-bootstrap';
import { HiOutlineDocumentDownload, HiOutlineMail, HiOutlinePhone } from 'react-icons/hi';
// import { Link } from 'react-router-dom';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import HeaderDivider from 'components/shared/atoms/HeaderDivider/HeaderDivider';
import formatPhoneNumber from 'utils/formatPhoneNumber';
import BrandService from 'services/brand';
import VetService from 'services/vet';
// import config from 'config/config';
// Style
import './styles.scss';
// Constants
import TAGGING_PROCESS from 'constants/taggingProcess';
import TAGGING_GUIDE_FILES from 'constants/taggingGuideFiles';

const BUSINESS_CENTER_EXCLUSION = ['Patch & Purr'];

class TaggingGuide extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showContactCard: false,
            email: '',
            businessEmail: '',
            businessPhone: '',
            phoneNumber: '',
            brandName: '',
            brandEmail: '',
            fileUrl: '',
            taggingProcess: [],
        };
        this.getVetDetails();
    }

    /**
     * Gets the contact info of the brand
     */
    getBrandContact() {
        BrandService.getBrand(this.state.brandName)
            .then((response) => {
                if (!response?.data) {
                    return;
                }

                this.setState({
                    email: response.data.cstm.brand_email_c ?? '',
                    phoneNumber: formatPhoneNumber((response.data.phone_work ?? (JSON.parse(localStorage.getItem('vet'))?.business_center.cstm.phone_number_1_c) ?? ''), 3)
                });
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * Get Vet Detail
     */
    getVetDetails() {
        VetService.getVetDetails()
            .then((response) => {
                this.setState({ brandName: String(response.data.class_new_brand.name || "") });
                this.setState({ brandEmail: String(response.data.class_new_brand.cstm.brand_email_c || "").toLowerCase() });
                this.setState({ businessEmail: String(response.data.business_center.cstm.email_c || "").toLowerCase() });
                this.setState({ businessPhone: response.data.business_center.cstm.phone_number_1_c});
                this.getBrandContact();
                this.getFileUrl();
                this.getTaggingProcess();
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * @todo Adjust the brands once is deployed and the brands are permanent
     * @returns {string} Returns the url of the tagging guide file
     */
    getFileUrl = () => {
        const EXCLUDE_FROM_EMAIL_SEARCH = ['Patch & Purr', 'Pets at Peace CW'];
        const brandFile = TAGGING_GUIDE_FILES.find((fileObj) => {
            if (EXCLUDE_FROM_EMAIL_SEARCH.includes(this.state.brandName)) {
                return fileObj.brand === this.state.brandName;
            }
            return fileObj.email === this.state.businessEmail;
        });
        brandFile && this.setState({ fileUrl: brandFile.url });
    }

    getTaggingProcess = () => {
        if(this.state.brandName.includes("Lawnswood")) {
            this.setState({ taggingProcess: TAGGING_PROCESS.tagsLW });
        }

        if(this.state.brandName.includes("Edenhills")) {
            this.setState({ taggingProcess: TAGGING_PROCESS.tagsEH });
        }

        if(this.state.brandName.includes("Pets in Peace")) {
            this.setState({ taggingProcess: TAGGING_PROCESS.tagsQLD });
        }

        if(this.state.brandName.includes("Patch & Purr")) {
            this.setState({ taggingProcess: TAGGING_PROCESS.tagsNSW });
        }

        if (this.state.brandName.includes("Pets at Peace CW")) {
            this.setState({ taggingProcess: TAGGING_PROCESS.tagsPaP });
        }
    }    

    render() {
        return (
            <div>
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="Tagging guide" />
                    <ContentCard
                        className="mt-62 tagging-content-card"
                        divider={false}
                        headerTitle="Tagging process"
                        headerBtnText="View more"
                        headerSubComponent={(
                            <p className="sub-header">
                                Understanding the tagging system ensures efficient turnaround.
                                The steps below will clarify how you can minimise delays in completion of bookings.
                            </p>
                        )}
                    >
                        <div className="tagging-container">
                            {
                                TAGGING_PROCESS.steps.map((step, index, arr) => (
                                    <div className="steps-container" key={index}>
                                        <HeaderDivider title={TAGGING_PROCESS.steps.length - 1 > index ? `Step ${index + 1}` : ''} />
                                        <p>
                                            {step}
                                        </p>
                                        {
                                            index === 1
                                                ? (
                                                    <div className="tagging-container">
                                                        {
                                                            this.state.taggingProcess.map((tag) => (
                                                                <Row key={tag.title}>
                                                                   <Row key={tag.title}>
                                                                    <Col>
                                                                        <Image src={tag.img} width={160} />
                                                                    </Col>
                                                                    <Col>
                                                                        <Image src={tag.imgBack} width={60} />
                                                                    </Col>
                                                                    <Col>
                                                                        <HeaderDivider title={tag.title} />
                                                                        <p className="newline">{tag.description}</p>
                                                                    </Col>
                                                                </Row>
                                                                </Row>
                                                            ))
                                                        }
                                                    </div>
                                                ) : null
                                        }
                                    </div>
                                ))
                            }
                        </div>
                        <div className="tag-contact-details">
                            <Button
                                className="tag-button"
                                onClick={() => this.setState({ showContactCard: true })}
                            >
                                Contact Client Care
                            </Button>
                            <Button
                                onClick={() => window.open(this.state.fileUrl, "_blank")}
                                className="tag-button"
                            >
                                <span>Download Tagging Guide</span>
                                <HiOutlineDocumentDownload size="20" />
                            </Button>
                        </div>
                    </ContentCard>
                </div>
                <Modal
                    className="contact-modal"
                    show={this.state.showContactCard}
                    onHide={() => this.setState({ showContactCard: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Contact Client Care</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <HeaderDivider
                            title={(
                                <span>
                                    <HiOutlineMail size="18" />
                                    Email:
                                    <a href={`mailto:${BUSINESS_CENTER_EXCLUSION.includes(this.state.brandName) ? this.state.brandEmail : this.state.businessEmail}`} className="underline">{BUSINESS_CENTER_EXCLUSION.includes(this.state.brandName) ? this.state.brandEmail : this.state.businessEmail}</a>
                                </span>
                            )}
                        />
                        <HeaderDivider
                            title={(
                                <span>
                                    <HiOutlinePhone size="18" />
                                    Phone:
                                    <a href={`tel:${this.state.businessPhone}`} className="underline">{this.state.businessPhone}</a>
                                </span>
                            )}
                        />
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default TaggingGuide;
